import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface LoadingState {
  isAuthLoading: boolean
  isTenantLoading: boolean
  isRedirectLoading: boolean
  isSecurityLoading: boolean
}

const initialState: LoadingState = {
  isAuthLoading: false,
  isTenantLoading: false,
  isRedirectLoading: false,
  isSecurityLoading: false,
}

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.isAuthLoading = action.payload
    },
    setTenantLoading: (state, action: PayloadAction<boolean>) => {
      state.isTenantLoading = action.payload
    },
    setRedirectLoading: (state, action: PayloadAction<boolean>) => {
      state.isRedirectLoading = action.payload
    },
    setSecurityLoading: (state, action: PayloadAction<boolean>) => {
      state.isSecurityLoading = action.payload
    },
  },
})

export const {
  setAuthLoading,
  setTenantLoading,
  setRedirectLoading,
  setSecurityLoading,
} = loadingSlice.actions

const loadingReducer = loadingSlice.reducer

export default loadingReducer
